import ptInputV1 from './src/index.vue';

ptInputV1.install = function(vue: { component: (arg0: any, arg1: any) => void; }) {
    vue.component(ptInputV1.name, ptInputV1);
};

export default ptInputV1;
